
    import './styles.scoped.css';
    export default {
  "expandable-toggle-wrapper": "awsui_expandable-toggle-wrapper_c6tup_98ns9_99",
  "body-cell": "awsui_body-cell_c6tup_98ns9_107",
  "body-cell-content": "awsui_body-cell-content_c6tup_98ns9_121",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_98ns9_124",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_98ns9_136",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_98ns9_148",
  "body-cell-expandable-level-1": "awsui_body-cell-expandable-level-1_c6tup_98ns9_151",
  "body-cell-expandable-level-2": "awsui_body-cell-expandable-level-2_c6tup_98ns9_154",
  "body-cell-expandable-level-3": "awsui_body-cell-expandable-level-3_c6tup_98ns9_157",
  "body-cell-expandable-level-4": "awsui_body-cell-expandable-level-4_c6tup_98ns9_160",
  "body-cell-expandable-level-5": "awsui_body-cell-expandable-level-5_c6tup_98ns9_163",
  "body-cell-expandable-level-6": "awsui_body-cell-expandable-level-6_c6tup_98ns9_166",
  "body-cell-expandable-level-7": "awsui_body-cell-expandable-level-7_c6tup_98ns9_169",
  "body-cell-expandable-level-8": "awsui_body-cell-expandable-level-8_c6tup_98ns9_172",
  "body-cell-expandable-level-9": "awsui_body-cell-expandable-level-9_c6tup_98ns9_175",
  "body-cell-expandable-level-next": "awsui_body-cell-expandable-level-next_c6tup_98ns9_178",
  "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_98ns9_181",
  "body-cell-interactive": "awsui_body-cell-interactive_c6tup_98ns9_181",
  "body-cell-editable": "awsui_body-cell-editable_c6tup_98ns9_181",
  "has-striped-rows-sticky-cell-pad-left": "awsui_has-striped-rows-sticky-cell-pad-left_c6tup_98ns9_247",
  "has-selection": "awsui_has-selection_c6tup_98ns9_280",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_98ns9_316",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_98ns9_319",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_98ns9_319",
  "has-footer": "awsui_has-footer_c6tup_98ns9_319",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_98ns9_329",
  "sticky-cell": "awsui_sticky-cell_c6tup_98ns9_355",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_c6tup_98ns9_363",
  "sticky-cell-last-right": "awsui_sticky-cell-last-right_c6tup_98ns9_410",
  "sticky-cell-last-left": "awsui_sticky-cell-last-left_c6tup_98ns9_414",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_98ns9_437",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_98ns9_441",
  "body-cell-editor-wrapper": "awsui_body-cell-editor-wrapper_c6tup_98ns9_465",
  "body-cell-success": "awsui_body-cell-success_c6tup_98ns9_472",
  "body-cell-editor": "awsui_body-cell-editor_c6tup_98ns9_465",
  "body-cell-editor-disabled": "awsui_body-cell-editor-disabled_c6tup_98ns9_499",
  "body-cell-editor-form": "awsui_body-cell-editor-form_c6tup_98ns9_508",
  "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_98ns9_518",
  "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_98ns9_528",
  "body-cell-expandable": "awsui_body-cell-expandable_c6tup_98ns9_151",
  "expandable-cell-content": "awsui_expandable-cell-content_c6tup_98ns9_552",
  "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_98ns9_600",
  "body-cell-has-success": "awsui_body-cell-has-success_c6tup_98ns9_604"
};
  